<template>
  <div class="py-12 block-trust">
    <bimContainer>
      <bimCol cols=12 md=10 class="mx-auto">
        <bim-text type=h4 bold class="text-center">Нам доверяют</bim-text>
        <bim-text type=main class="mb-12 mt-9 text-center">Ведущие проектные институты и компании загружают BIM-библиотеки у нас</bim-text>
        <div class="manufacturer__wrapper d-flex">
          <div
            v-for="img of manufacturers"
            :key="img"
            class="manufacturer__item d-flex justify-center align-center"
          >
            <transition class="animation-image">
              <img v-if="img" class="manufacturer__item-image" :src="img" />
            </transition>
            <transition name="animation-loading">
              <div class="loading-wrapper" v-if="!img">
                <div class="loading"></div>
              </div>
            </transition>
          </div>
        </div>
        <bim-text type=accent bold class="text-center mt-12">Порталом пользуются:</bim-text>
        <div class="info__wrapper d-flex">
          <div
            v-for="item of info"
            :key="item.title"
            class="info__item d-flex flex-column"
          >
            <bim-text type=medium bold class="info__title mb-3">{{ item.title }}</bim-text>
            <bim-text type=medium class="flex-grow-1">{{ item.desc }}</bim-text>
          </div>
        </div>
        <bim-text type=main class="text-center mt-12">Ваш продукт может попасть к любому из названных участников портала в один клик.</bim-text>
      </bimCol>
    </bimContainer>
  </div>
</template>

<script>
import bimContainer from "@bimlib/components/bimContainer"
import bimCol from "@bimlib/components/bimCol"
import { mapState } from 'vuex'

const logosArray = ["10.png","101.png","104.png","107.png","11.png","114.png","115.png","116.png","117.png","118.png","119.png","12.png","121.png","122.png","124.png","129.png","13.png","130.png","131.png","132.png","133.png","135.png","136.png","138.png","139.png","140.png","144.png","146.png","147.png","148.png","16.png","19.png","23.png","24.png","25.png","3.png","32.png","34.png","35.png","37.png","39.png","4.png","47.png","48.png","5.png","50.png","51.png","56.png","62.png","67.png","69.png","70.png","77.png","78.png","79.png","80.png","82.png","83.png","84.png","85.png","86.png","89.png","90.png","93.png","94.png","95.png","96.png","98.png"]
const imgPath = '/dist/assets/front_white/img/companies_logo'
const logosVisibleCount = 30

export default {
  components: {
    bimContainer,
    bimCol,
  },
  data() {
    return {
      manufacturers: new Array(logosVisibleCount),
    }
  },
  created() {
    this.getManufacturers()
  },
  computed: {
    ...mapState('counters', [
      'russia_manufacturer_count',
      'designer_count',
      'des_eng_company_count',
      'international_company_count'
    ]),
    info() {
      return [
        {
          title: this.russia_manufacturer_count,
          desc: 'Крупнейшие российские компании',
        },
        {
          title: this.designer_count,
          desc: 'Проектировщиков',
        },
        {
          title: this.des_eng_company_count,
          desc: 'Российских проектных бюро и инжиниринговых компаний',
        },
        {
          title: this.international_company_count,
          desc: 'Международных компаний',
        },
      ]
    }
  },
  methods: {
    getManufacturers() {
      const len = logosArray.length
      const indexArray = []
      let currentImgIndex = -1

      generateArray = generateArray.bind(this)
      generateArray()

      function generateArray() {
        if (currentImgIndex >= logosVisibleCount - 1) return

        let search = true
        while (search) {
          const index = parseInt(Math.random() * len)

          if (!indexArray.includes(index)) {
            search = false
            indexArray.push(index)
            const _index = ++currentImgIndex

            setTimeout(() => {
              const path = `${imgPath}/${logosArray[index]}`
              this.loadImage(path)
                .then(() => {
                  this.manufacturers.splice(_index, 1, path)
                })
                .catch(console.error)
            })
          }
        }

        setTimeout(generateArray)
      }
    },
    loadImage(path) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.src = path
        img.onload = resolve
        img.onerror = reject
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";

.text-center {
  text-align: center;
}

.block-trust {
  background-color: #fafafa;
}

.info__wrapper {
  margin-top: 60px;
  text-align: center;
  flex-wrap: wrap;

  .info__title {
    color: $primary-color;
    font-size: 42px;
  }
  .info__item {
    flex: 0 0 25%;
    padding: 16px;

    @media screen and (max-width: $breakpoint-xl) {
      flex: 0 0 50%;
    }
    @media screen and (max-width: $breakpoint-sm) {
      flex: 0 0 100%;
    }
  }
}

.manufacturer__wrapper {
  flex-wrap: wrap;
  justify-content: center;

  .manufacturer__item {
    margin-right: 33px;
    margin-bottom: 42px;
    min-width: 50px;
    min-height: 50px;
    max-height: 100px;
    flex: 0 0 9.45%;

    .manufacturer__item-image {
      width: 100%;
      max-height: 100%;
      object-fit: contain;
      background: #efefef;
      padding: 10px;
      border-radius: 5px;
    }

    .loading-wrapper {
      position: absolute;
      width: 100%;
      height: 100%;

      .loading {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, 50%);
        width: 30px;
        height: 30px;
      }
    }


    @media screen and (min-width: $breakpoint-xl) {
      &:nth-child(8n) {
        margin-right: 0;
      }
    }

    @media screen and (min-width: $breakpoint-lg) and (max-width: $breakpoint-xl) {
      flex: 0 0 10.37%;
      &:nth-child(7n) {
        margin-right: 0;
      }
    }

    @media screen and (min-width: $breakpoint-md) and (max-width: $breakpoint-lg) {
      flex: 0 0 15.3%;
      &:nth-child(5n) {
        margin-right: 0;
      }
    }
    @media screen and (min-width: $breakpoint-sm) and (max-width: $breakpoint-md) {
      flex: 0 0 20.1%;
      &:nth-child(4n) {
        margin-right: 0;
      }
    }
    @media screen and (min-width: $breakpoint-xs) and (max-width: $breakpoint-sm) {
      flex: 0 0 16%;
      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }

  .manufacturer__logo {
    object-fit: contain;
  }
}

.loading {
  height: 30px;
  width: 30px;
  top: 20px;
  border: 2px solid black;
  border-radius: 50%;
  border-top-color: #fff;
  animation: loading 1s infinite linear;
}

@keyframes loading {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
